import classNames from 'classnames';
import React from 'react';
const ErrorBox = (props) => {
    if (!props.errors || props.errors.length === 0 || props.errors.every((err) => err === '')) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: classNames('globalerrors', 'invalid-feedback', props.className), role: "alert" }, props.errors.map((e, i) => (React.createElement("div", { key: i }, (e || '').toString())))));
};
export default ErrorBox;
